export default "__VITE_ASSET__H4Mkb5yl__"